import { useStoreOwner } from '@/features/users/store-owner/hooks/useStoreOwner';
import { OwnersTable } from '@/features/users/store-owner/table';
import { createFileRoute, SearchSchemaInput } from '@tanstack/react-router';
import { z } from 'zod';

const sortItemSchema = z.object({
  id: z.enum(['reward', 'phoneNumber', 'emailAddress', 'clubNameEng', 'clubCeoNameEng', 'createdDate', 'updatedDate']),
  desc: z.boolean(),
});

const StoreOwnerSearchSchema = z.object({
  sort: z
    .preprocess((val) => {
      if (typeof val === 'string') {
        try {
          return JSON.parse(val);
        } catch {
          return undefined;
        }
      }
      return val;
    }, z.array(sortItemSchema))
    .optional(),
  createdDate: z
    .string()

    .optional(),

  q: z
    .any()
    .transform((val) => (val == null ? undefined : String(val)))
    .optional(),

  status: z
    .string()
    .transform((val) => val.split(','))
    .pipe(z.array(z.enum(['ACTIVE', 'INACTIVE'])))
    .optional(),

  page: z.coerce.number().positive().catch(0),
  fetch: z.coerce.number().positive().max(100).catch(10),
});

export const Route = createFileRoute('/(app)/users/store-owners/')({
  component: RouteComponent,
  validateSearch: (search: SearchSchemaInput) => StoreOwnerSearchSchema.parse(search),
});

function RouteComponent() {
  const { data, isLoading, pagination } = useStoreOwner();
  const ownersData = data?.data ?? [];
  return (
    <>
      <OwnersTable data={ownersData} isLoading={isLoading} pagination={pagination} />
    </>
  );
}
